import React, { Component } from 'react'
import { Container, Row, Col, Tabs, Tab, Table } from 'react-bootstrap'
import Footer from './Footer'
import HeaderTop from './HeaderTop'
import SideNavTop from './SideNavTop'
import '../Accueil.css'


class CampEte extends Component {
    state = {
        redirect: false,
        search: '',
        key: 'maitre'
    }

    handleCHange = event => {
        const { name, value } = event.target
        this.setState({ [name]: value })
    }

    handleSubmit = event => {
        //on gere le form
        event.preventDefault()
        this.props.history.push(`/recherche/${this.state.search}`);

    }

    setRedirect = () => {
        this.setState({
          redirect: true
        })
      }

    handleSubmitFacebbok = () => {
        if (this.state.redirect) {
            window.location.href = "https://www.facebook.com/clubCAPN/";
        }
    }

    handleSelect(key) {
        if (key === "maitre")
            this.props.history.push(`/competiton/maitres-nageurs`);
        else if (key === "natation")
            this.props.history.push(`/competiton/natation`);
        else if (key === "sauvetage")
            this.props.history.push(`/competiton/sauvetage-sportif`);
        else if (key === "resultat")
            this.props.history.push(`/competiton/resultats`);
        else if (key === "synchro")
            this.props.history.push(`/competiton/nage-synchronisee`);
    }

    render() {
        console.log(this.state.key)
        return (
            <>
                <Container fluid>
                <Row>
            <SideNavTop/>
            <Col lg={10} md={12} sm={12} xs={12} id="page-content-wrapper" className="nopadding">
              <HeaderTop
                handleSubmit={this.handleSubmit}
                handleCHange={this.handleCHange}
                handleSubmitFacebbok={this.handleSubmitFacebbok}
                setRedirect={this.setRedirect}
              />

                            <Col lg={12} md={12} sm={12} xs={12} className="nopadding">

                                <Tabs
                                    id="controlled-tab"
                                    activeKey={this.state.key}
                                    onSelect={key => this.handleSelect(key)}
                                >                       <Tab eventKey="maitre" title="Maître Nageurs">
                                    </Tab>
                                    <Tab eventKey="synchro" title="Nage synchronisée">
                                    </Tab>
                                    <Tab eventKey="natation" title="Natation" >
                                    </Tab>
                                    <Tab eventKey="sauvetage" title="Sauvetage sportif">
                                    </Tab>
                                    <Tab eventKey="resultat" title="Résultat Compétition" >
                                    </Tab>
                                </Tabs>
                            </Col>


                            <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                                <Row>
                                    <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                                        <div className="histoire-content">
                                            <h1><span>CAMP DE JOUR ÉTÉ 2020</span></h1>
                                            <h2>Les inscriptions pour le camp de jour du CAPN débuteront le 8 février 2020 via Amilia.</h2>
                                            <p className="pCenter"><i> ** IMPORTANT! : Afin d'avoir la possibilité de réussir un niveau de la Croix-Rouge,
                                                 les enfants doivent être inscrits au camp de jour pour 2 semaines consécutives.</i><br />                                     
                                            IMPORTANT, voici un communiqué du président du Conseil d'adminsitration.<br />
                                            </p>
                                            <Col lg={12} md={12} sm={12} xs={12} className="nopadding link-emploi">
                                                <a href="/Communiqué_CAPN-CampJour.pdf" className="btn btn-primary btn-blue-light emploi" target="_blank" download>
                                                INFORMATIONS CAMP DE JOUR
                                                </a>
                                            </Col>

                                            <h2>Lieu</h2>
                                            <p className="pCenter">
                                            - Le camp de jour se déroule à l'école Sophie-Barat.<br />
                                            - Les cours de natation se dérouleront à la piscine Sophie-Barat ( à préciser)<br />
                                            - Les enfants vont au parc et dans les piscines extérieures de l'arrondissement. <br /><br />
                                            </p>
                                            <h2>Horaire type</h2>

                                            <Table striped bordered hover>
                                            <thead>
                                                <tr>
                                                <th></th>
                                                <th className="table-resp">Lundi</th>
                                                <th className="table-resp-Camp">Lundi-Mardi-Mercredi-Vendredi</th>

                                                <th className="table-resp">Mardi</th>
                                                <th className="table-resp">Mercredi</th>
                                                <th>Jeudi</th>
                                                <th className="table-resp">Vendredi</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>9h00 à 9h30</td>
                                                    <td>Accueil des jeunes</td>
                                                    <td className="table-resp">Accueil des jeunes</td>
                                                    <td className="table-resp">Accueil des jeunes</td>
                                                    <td>Accueil des jeunes</td>
                                                    <td className="table-resp">Accueil des jeunes</td>
                                                </tr>
                                                <tr>
                                                    <td>9h30 à 9h45</td>
                                                    <td>On se change pour aller faire des courses</td>
                                                    <td className="table-resp">On se change pour aller faire des courses</td>
                                                    <td className="table-resp">On se change pour aller faire des courses</td>
                                                    <td rowspan="7">Sortie*!!!</td>
                                                    <td className="table-resp">On se change pour aller faire des courses</td>
                                                </tr>
                                                <tr>
                                                    <td>9h45 à 10h45</td>
                                                    <td>Cours de natation</td>
                                                    <td className="table-resp">Cours de natation</td>
                                                    <td className="table-resp">Cours de natation</td>
                                                    <td className="table-resp">Cours de natation</td>
                                                </tr>
                                                <tr>
                                                    <td>10h45 à 11h30</td>
                                                    <td>Baignade libre</td>
                                                    <td className="table-resp">Baignade libre</td>
                                                    <td className="table-resp">Baignade libre</td>
                                                    <td className="table-resp">Baignade libre</td>
                                                </tr>
                                                <tr>
                                                    <td>11h30 à 12h00</td>
                                                    <td>On se change!</td>
                                                    <td className="table-resp">On se change!</td>
                                                    <td className="table-resp">On se change!</td>
                                                    <td className="table-resp">On se change!</td>
                                                </tr>
                                                <tr>
                                                    <td>12h00 à 13h00</td>
                                                    <td>Diner!</td>
                                                    <td className="table-resp">Diner!</td>
                                                    <td className="table-resp">Diner!</td>
                                                    <td className="table-resp">Diner!</td>
                                                </tr>
                                                <tr>
                                                    <td>13h00 à 15h45</td>
                                                    <td>Jeux sportifs</td>
                                                    <td className="table-resp">Jeux sportifs</td>
                                                    <td className="table-resp">Jeux sportifs</td>
                                                    <td className="table-resp">Jeux sportifs</td>
                                                </tr>
                                                <tr>
                                                    <td>15h45 à 16h00</td>
                                                    <td>Collation et au revoir</td>
                                                    <td className="table-resp">Collation et au revoir</td>
                                                    <td className="table-resp">Collation et au revoir</td>
                                                    <td className="table-resp">Collation et au revoir</td>
                                                </tr>
                                            </tbody>
                                            </Table>
                                            <p  className="pCenter"><i> *La sortie peut avoir lieu le vendredi</i></p>     

                                            <h2>Tarif</h2>

                                            <Table striped bordered hover>
                                            <thead>
                                                <tr>
                                                <th>Cours</th>
                                                <th>Tarification</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td><strong>Camp de jour aquatique</strong></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>Camp de jour (9h00 à 16h00)</td>
                                                    <td><strong>150$ / semaine</strong></td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Camp de natation uniquement</strong></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>Cours Croix-Rouge(9h45 à 11h30)</td>
                                                    <td><strong>60$ / semaine</strong></td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Service de garde</strong></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>Matin(7h00 à 9h00)</td>
                                                    <td><strong>35$ / semaine</strong></td>
                                                </tr>
                                                <tr>
                                                    <td>Soir(7h00 à 18h00)</td>
                                                    <td><strong>35$ / semaine</strong></td>
                                                </tr>
                                                <tr>
                                                    <td>Matin et soir</td>
                                                    <td><strong>60$ / semaine</strong></td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Accessoires</strong></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>Chandail du camp</td>
                                                    <td><strong>15$</strong></td>
                                                </tr>
                                                <tr>
                                                    <td>Carnet de cours de natation</td>
                                                    <td><strong>5$</strong></td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                        <h3>Rabais</h3>                                           
                                        <p className="pCenter"><i> Un rabais de 10$ par enfant supplémentaire de la même famille est accordé.</i><br /></p>
                                        <h2>Dates</h2>

                                        <p className="pCenter"><i>SEMAINE 1: </i> 22 au 26 juin 2020<br />
                                        <i>SEMAINE 2: </i> 29 juin au 3 juillet 2020<br />
                                        <i>SEMAINE 3: </i>6 au 10 juillet 2020<br />
                                        <i>SEMAINE 4: </i> 13 au 17 juillet 2020<br />
                                        <i>SEMAINE 5: </i>20 au 24 juillet 2020<br />
                                        <i>SEMAINE 6: </i>27 au 31 juillet 2020<br />
                                        <i>SEMAINE 7:</i>3 au 7 août 2020<br />
                                        <i>SEMAINE 8:</i>10 au 14 août 2020<br /></p> 
                                    </div>
                                    </Col>
                                </Row>
                            </Col>

                            <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                                <Footer />
                            </Col>
                        </Col>
                    </Row>
                </Container>
            </>
        )
    }
}

export default CampEte
